module.exports = __webpack_public_path__ + "img/twitter-icon.1f75d678.png";